<template>
  <div>
    <!-- <div>
      <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

    </div> -->
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- begin                                                                         -->
    <v-card class="box" v-if="ay_list != null">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>
          <strong> Academic Planner </strong>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn class="mb-2 button" color="warning" @click="mark_holiday_dialog = true" small>Mark Weekly-Off</v-btn>
      </v-toolbar>
      <v-row justify="center" dense>
        <v-col cols="12" sm="2">
          <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
          <v-autocomplete color="#0F2027" dense rounded required v-model="ay" :items="ay_list" item-text="ay"
            item-value="id" label="Academic Year" outlined persistent-hint hint="Please Select Academic Year" />
        </v-col>
        <!-- <v-col cols="12" sm="2" v-if="this.standard_list.length > 0">
          <p><b>Standard</b></p>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="standard"
            :items="standard_list"
            item-text="standard"
            item-value="id"
            label="Standard"
            outlined
            persistent-hint
            hint="Please Select Standard"
            multiple
          />
        </v-col> -->
        <!-- <v-col cols="12" sm="2" v-if="this.division_offering_list.length > 0">
          <p><v-icon color="error">*</v-icon><b>Division</b></p>
          <v-autocomplete
            color="#0F2027"
            dense
            rounded
            required
            v-model="div_off"
            :items="division_offering_list"
            item-text="division"
            item-value="id"
            multiple
            label="Division"
            outlined
            persistent-hint
            hint="Please Select Division"
          />
        </v-col> -->
        <v-col cols="12" sm="2">
          <p><v-icon color="error">*</v-icon><b>Event Type</b></p>
          <v-autocomplete color="#0F2027" dense rounded required v-model="event_type" :items="event_type_list"
            item-text="name" item-value="id" label="Event Type" outlined persistent-hint
            hint="Please Select Event Type" />
        </v-col>
      </v-row>
      <v-row justify="center" dense>
        <v-col cols="12" sm="3" md="3">
          <p><v-icon color="error">*</v-icon><b>From Date</b></p>
          <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false" transition="scale-transition" offset-y
            max-width="290px" min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field dense v-model="selected_date" v-bind="attrs" v-on="on" prepend-icon="event"
                hint="This Date Is Inclusive" persistent-hint></v-text-field>
            </template>
            <v-date-picker v-model="date" no-title @input="menu1 = false"></v-date-picker>
          </v-menu>
        </v-col>
        <v-col cols="12" sm="2" md="3">
          <p><v-icon color="error">*</v-icon><b>To Date</b></p>
          <v-menu ref="menu2" v-model="menu2" :close-on-content-click="false" transition="scale-transition" offset-y
            max-width="290px" min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field dense v-model="to_date" v-on="on" v-bind="attrs" prepend-icon="event"
                hint="This Date Is Exclusive" persistent-hint></v-text-field>
            </template>
            <v-date-picker v-model="todate" no-title @input="menu2 = false"></v-date-picker>
          </v-menu>
        </v-col>
      </v-row>
      <v-row justify="center" dense>
        <v-col cols="12" sm="5" md="5">
          <p><v-icon color="error">*</v-icon><b>Title</b></p>
          <v-text-field outlined dense type="text" v-model="title"></v-text-field>
        </v-col>
      </v-row>
      <v-row justify="center" dense>
        <v-col cols="12" sm="5" md="5">
          <p><b>Description</b></p>
          <v-textarea outlined name="input-7-4" v-model="description" label="Enter Description"></v-textarea>
        </v-col>
      </v-row>
      <v-row justify="center" dense v-if="this.event_type && this.title">
        <v-col cols="12" sm="1" md="1"></v-col>
        <v-col col="12" sm="2" md="2">
          <v-btn color="warning" @click="addPlanningData()">Save</v-btn>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="box" v-if="planning_list.length > 0">
      <v-toolbar class="toolbar" flat dense>
        <v-toolbar-title>Academic Planning Data</v-toolbar-title>
        <v-divider class="mx-4" inset vertical></v-divider>
        <v-spacer></v-spacer>
      </v-toolbar>
      <!-- <v-row justify="center">
        <v-col cols="12" md="2" sm="2"> </v-col>
        <v-col cols="12" md="4" sm="4">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Search"
            single-line
            hide-details
          ></v-text-field>
        </v-col>
       
      </v-row> -->
      <v-data-table :headers="headers" :items="bookList1" :search="search" @current-items="getFiltered">
        <!-- <template v-slot:top>
          <v-toolbar flat class="toolbar">
            <v-toolbar-title>Academic Planning Data</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
          </v-toolbar>
        </template> -->
        <template v-slot:[`item.edit`]="{ item }">
          <div>
            <v-avatar size="25" class="edit-avatar">
              <v-icon class="mr-2 edit-v-icon" @click="editItem(item)" title="edit">edit</v-icon>
            </v-avatar>
          </div>
        </template>
        <template v-slot:[`item.delete`]="{ item }">
          <div>
            <v-avatar size="35">
              <v-icon class="mr-4 v-icon-size" color="red" @click="deletePlanData(item)">mdi-trash-can</v-icon>
            </v-avatar>
          </div>
        </template>
        <template v-slot:[`item.isweeklyoff`]="{ item }">
          <v-switch v-model="item.isweeklyoff" :color="item.isweeklyoff ? 'success' : 'primary'"
            @change="toggle(item)"></v-switch>
          <!-- <span v-if="item.isweeklyoff">
            <v-icon class="mr-2 v-icon-size" color="success"
              >mdi-check-circle-outline</v-icon
            >
          </span>
          <span v-else>
            <v-icon class="mr-2 v-icon-size" color="error"
              >mdi-close-circle-outline</v-icon
            >
          </span> -->
        </template>
        <template v-slot:top class="pb-5">
          <v-row>
            <v-col cols="12" sm="1" md="1"></v-col>
            <tr class="t-row">
              <div>
                <th>
                  <v-row>
                    <span v-for="header in headers" :key="header.text">
                      <span v-if="filters.hasOwnProperty(header.value)">
                        <v-autocomplete class="mr-2 pb-5 pt-2" flat hide-details small rounded dense outlined
                          color="#0F2027" :label="header.text" multiple clearable :items="columnValueList(header.value)"
                          v-model="filters[header.value]"></v-autocomplete>
                      </span>
                    </span>
                  </v-row>
                </th>
              </div>
            </tr>
            <v-col cols="12" sm="1" md="1"></v-col>
            <v-col cols="12" md="4" sm="4">
              <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line
                hide-details></v-text-field>
            </v-col>
          </v-row>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="edit_dialog" max-width="1200px">
      <v-card>
        <v-toolbar class="toolbar" flat dense>
          <v-toolbar-title>
            <strong> Academic Planner </strong>
          </v-toolbar-title>
        </v-toolbar>
        <v-col cols="12" sm="12" md="12">
          <v-card class="box">
            <v-row justify="center" dense>
              <v-col cols="12" sm="6" md="4">
                <p><b>Title*</b></p>
                <v-text-field outlined dense type="text" v-model="editRecord.title"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><v-icon color="error">*</v-icon><b>Event Date</b></p>
                <!-- <v-menu ref="menu1" v-model="menu5" :close-on-content-click="false" transition="scale-transition" offset-y max-width="290px" min-width="290px">
            <template v-slot:activator="{ on, attrs }">
              <v-text-field dense v-model="editRecord.date_edit" v-bind="attrs" v-on="on" prepend-icon="event" persistent-hint></v-text-field>
            </template>
            <v-date-picker v-model="edit_date" no-title @input="menu5 = false"></v-date-picker>
          </v-menu> -->
                <v-dialog ref="dialog" v-model="menu5" :return-value.sync="editRecord.date_edit" persistent
                  width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field v-model="editRecord.date_edit" rounded outlined dense prepend-icon="mdi-calendar"
                      hint="YYYY-MM-DD FORMAT" readonly v-bind="attrs" v-on="on"></v-text-field>
                  </template>
                  <v-date-picker v-model="editRecord.date_edit" scrollable>
                    <v-spacer></v-spacer><v-btn text color="primary" @click="menu5 = false">Cancel</v-btn>
                    <v-btn text color="primary" @click="$refs.dialog.save(editRecord.date_edit)">OK</v-btn>
                  </v-date-picker>
                </v-dialog>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>Description</b></p>
                <v-textarea outlined name="input-7-4" v-model="editRecord.description"
                  label="Update Description"></v-textarea>
              </v-col>
            </v-row>
            <v-row justify="center" dense>
              <v-btn class="button" @click="updatePlanningData()" :loading="loader">Update</v-btn>
              <v-btn class="button" @click="edit_dialog = false">Close</v-btn>
            </v-row>
          </v-card>
        </v-col>
      </v-card>
    </v-dialog>

    <v-dialog v-model="mark_holiday_dialog" max-width="1200px">
      <v-card>
        <v-toolbar class="toolbar" flat dense>
          <v-toolbar-title>
            <strong> Mark Weekly-Off</strong>
          </v-toolbar-title>
        </v-toolbar>
        <v-col cols="12" sm="12" md="12">
          <v-card class="box">
            <v-row justify="center" dense>
              <v-col cols="12" sm="2">
                <p><v-icon color="error">*</v-icon><b>Academic Year</b></p>
                <v-autocomplete color="#0F2027" dense rounded required v-model="mark_holiday_ay" :items="ay_list"
                  item-text="ay" item-value="id" label="Academic Year" outlined persistent-hint
                  hint="Please Select Academic Year" />
              </v-col>
              <!-- <v-col cols="12" sm="2" v-if="is_applicable_for_particular_standard == true">
              <p><v-icon color="error">*</v-icon><b>Standard</b></p>
              <v-autocomplete
                color="#0F2027"
                dense
                rounded
                required
                v-model="particular_standard"
                :items="standard_list"
                item-text="standard"
                item-value="id"
                label="Standard"
                outlined
                persistent-hint
                hint="Please Select Standard"
                multiple
              />
        </v-col> -->
              <v-col cols="12" sm="3">
                <p><v-icon color="error">*</v-icon><b>From Date</b></p>
                <v-menu ref="menu3" v-model="menu3" :close-on-content-click="false" transition="scale-transition"
                  offset-y max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field dense v-model="holiday_from" v-bind="attrs" v-on="on" prepend-icon="event"
                      persistent-hint></v-text-field>
                  </template>
                  <v-date-picker v-model="holidayfrom" no-title @input="menu3 = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="3">
                <p><v-icon color="error">*</v-icon><b>To Date</b></p>
                <v-menu ref="menu4" v-model="menu4" :close-on-content-click="false" transition="scale-transition"
                  offset-y max-width="290px" min-width="290px">
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field dense v-model="holiday_to" v-bind="attrs" v-on="on" prepend-icon="event"
                      persistent-hint></v-text-field>
                  </template>
                  <v-date-picker v-model="holidayto" no-title @input="menu4 = false"></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="2">
                <p><v-icon color="error">*</v-icon><b>Day List</b></p>
                <v-autocomplete color="#0F2027" dense rounded required v-model="day" :items="day_list" item-text="day"
                  item-value="id" label="Day" multiple outlined persistent-hint hint="Please Select Day" />
              </v-col>
              <v-col cols="12" sm="2">
                <p><v-icon color="error">*</v-icon><b>Mark Weekly Off</b></p>
                <v-checkbox v-model="is_weekly_off" label="Mark Weekly Off?"></v-checkbox>
                <!-- <v-autocomplete
                  color="#0F2027"
                  dense
                  rounded
                  required
                  v-model="mark_event_type"
                  :items="event_type_list"
                  item-text="name"
                  item-value="id"
                  label="Event Type"
                  outlined
                  persistent-hint
                  hint="Please Select Event Type"
                /> -->
              </v-col>
            </v-row>
            <v-row justify="center" dense>
              <v-col cols="12" sm="3">
                <p><v-icon color="error">*</v-icon><b>Title</b></p>
                <v-text-field outlined dense type="text" v-model="mark_title"></v-text-field>
              </v-col>
              <v-col cols="12" sm="3">
                <p><b>Description</b></p>
                <v-textarea outlined name="input-7-4" v-model="mark_description" label="Enter Description"></v-textarea>
              </v-col>
            </v-row>
            <v-row justify="center" dense>
              <v-btn class="button" @click="markHolidays()" :loading="loader">save</v-btn>
              <v-btn class="button" @click="mark_holiday_dialog = false">Close</v-btn>
            </v-row>
          </v-card>
        </v-col>
      </v-card>
    </v-dialog>

    <!-- shiv code calendar -->
    <v-card class="box">
      <calendar-inst v-if="renderComponent"></calendar-inst>
    </v-card>
    <!-- shiv code calendar end -->
  </div>
</template>

<script>
import axios from "axios";
import calendar_inst from "./InstructorCalendarAP.vue";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed

export default {
  components: {
    "calendar-inst": calendar_inst,
    Breadcrumbs
  },
  data: () => ({
    is_applicable_for_particular_standard: false,
    is_weekly_off: true,
    renderComponent: true,
    search: "",
    mark_holiday_dialog: false,
    snackbar_msg: "",
    color: "",
    snackbar: false,
    overlay: false,
    ///////////////////////////////////////////////
    event_type_list: null,
    sel_event: null,
    ay_list: [],
    ay: "",
    section_list: [],
    section: "",
    // extraBreadcrumbItems: [
  

    // ],
    // breadcrumbClass: "breadcrumb-style1",
    standard_list: [],
    standard: "",
    particular_standard: "",
    division_offering_list: [],
    div_off: "",
    event_type_list: [],
    day_list: [],
    day: "",
    mark_event_type: "",
    mark_holiday_ay: "",
    event_type: "",
    title: "",
    description: "",
    selected_date: "",
    holiday_from: "",
    holiday_to: "",
    to_date: "",
    date: new Date().toISOString().substr(0, 10),
    menu1: false,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    todate: new Date().toISOString().substr(0, 10),
    nowDate: new Date().toISOString().slice(0, 10),
    holidayfrom: new Date().toISOString().slice(0, 10),
    holidayto: new Date().toISOString().slice(0, 10),
    planning_list: [],
    mark_title: "",
    mark_description: "",
    // for calender

    // calender end
    headers: [
      { text: "SR NO", value: "count" },
      { text: "Title", value: "title" },
      { text: "Description", value: "description" },
      { text: "Date", value: "event_date" },
      { text: "Event Type", value: "eventtype" },
      //  { text: "Standard", value: "standard" },
      { text: "Is Weekly-Off", value: "isweeklyoff" },
      // { text: "Division", value: "divissionoffering" },
      { text: "Edit", value: "edit" },
      { text: "Delete", value: "delete" },
    ],
    editRecord: { title: "", description: "", id: "", date_edit: "" },
    edit_dialog: false,
    loader: false,
    filterArr: [],
    filters: {
      eventtype: [],
      standard: [],
      // subjectcode: [],
      // subject: [],
    },
  }),
  computed: {
    bookList1() {
      return this.planning_list.filter((d) => {
        return Object.keys(this.filters).every((f) => {
          return this.filters[f].length < 1 || this.filters[f].includes(d[f]);
        });
      });
    },
  },
  mounted() {
    this.onload();
    this.selected_date = this.formatDate(this.date);
    this.to_date = this.formatDate(this.todate);
    this.holiday_from = this.formatDate(this.holidayfrom);
    this.holiday_to = this.formatDate(this.holidayto);
    // for calender
  },
  watch: {
    date(val) {
      this.selected_date = this.formatDate(this.date);
    },
    todate(val) {
      this.to_date = this.formatDate(this.todate);
    },
    holidayfrom(val) {
      this.holiday_from = this.formatDate(this.holidayfrom);
    },
    holidayto(val) {
      this.holiday_to = this.formatDate(this.holidayto);
    },
    // std_id() {
    //   <calendar-demo></calendar-demo>;
    // },
  },
  methods: {
     toggle(item){
                const data = {
                    id:item.id,
                    isweeklyoff:item.isweeklyoff
                }
                axios
                    .post("/AcademicPlanner/updateIsWeeklyOff", data)
                    .then((res) => {
                        if (res.data.flag == "YES") {
                            this.showSnackbar("green", "Updated Successfully..."); 
                            this.planning_list = res.data.planning_list;
                        } else {
                            this.showSnackbar("#b71c1c", "Something Went Wrong...");
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something Went Wrong..."); // show snackbar
                    })
                    .finally(() => {
                        // 'use strict';
                    });
            },
    resetData() {
      (this.event_type = ""),
        (this.title = ""),
        (this.description = ""),
        (this.day = ""),
        (this.mark_title = ""),
        (this.mark_description = "");
    },
    getFiltered(e) {
      this.filterArr = e;
    },
    columnValueList(val) {
      console.log("in col fin", val);
      return this.planning_list.map((d) => d[val]);
    },
    markHolidays() {
      if (!confirm("Are You Sure You Want To Mark Holidays...?")) return;
      const formData = {
        holiday_from: this.holiday_from,
        holiday_to: this.holiday_to,
        day: this.day,
        event_type: this.mark_event_type,
        // standard:this.particular_standard,
        ay: this.mark_holiday_ay,
        title: this.mark_title,
        description: this.mark_description,
        is_weekly_off: this.is_weekly_off,
      };
      this.overlay = true;
      this.renderComponent = false;
      axios
        .post("/AcademicPlanner/markHolidaysForEmployee", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", "Marked Successfully..");
            this.mark_holiday_dialog = false;
            this.planning_list = res.data.planning_list;
            this.renderComponent = true;
            this.resetData();
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },

    deletePlanData(item) {
      if (!confirm("Are You Sure You Want To Delete...?")) return;
      const formData = {
        id: item.id,
      };
      this.overlay = true;
      axios
        .post("/AcademicPlanner/deletePlanDataInstructor", formData)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", "Deleted Successfully..");
            this.planning_list = res.data.planning_list;
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },

    editItem(item) {
      this.editRecord.title = item.title;
      this.editRecord.description = item.description;
      this.editRecord.id = item.id;
      this.editRecord.date_edit = item.date_edit;
      //this.editRecord.edit_date = item.date_edit.toISOString().slice(0, 10),
      this.edit_dialog = true;
    },
    updatePlanningData() {
      this.renderComponent = false;
      this.overlay = true;
      axios
        .post("/AcademicPlanner/updateInstructorPlanningData", this.editRecord)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", "Updated Successfully..");
            this.planning_list = res.data.planning_list;
            this.edit_dialog = false;
            this.renderComponent = true;
          }
          if (res.data.flag == "No") {
            this.showSnackbar("green", res.data.snackbar);
            this.planning_list = res.data.planning_list;
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.edit_dialog = false;
            this.renderComponent = true;
          } else {
           // this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
            this.edit_dialog = false;
          }
          this.overlay = false;
          this.edit_dialog = false;
        })
        .catch((error) => {
          // this.onerror(error);
          this.overlay = false;
          this.edit_dialog = false;
        })
        .finally(() => {
          this.overlay = false;
          this.edit_dialog = false;
          this.renderComponent = true;
          // this.selected_date=""
        });
    },
    addPlanningData() {
      if (this.to_date < this.selected_date) {
        this.showSnackbar(
          "red",
          "Please Select End Date Greater Than Start Date..."
        );
        return;
      }
      const data = {
        fromdate: this.selected_date,
        todate: this.to_date,
        ay: this.ay,
        //standard: this.standard,
        //div_off: this.div_off,
        title: this.title,
        description: this.description,
        event_type: this.event_type,
      };
      this.overlay = true;
      this.renderComponent = false;
      axios
        .post("/AcademicPlanner/saveAcademicPlanForEmployee", data)
        .then((res) => {
          if (res.data.flag == "YES") {
            this.showSnackbar("green", "Saved Successfully..");
            this.planning_list = res.data.planning_list;
            this.renderComponent = true;
            this.resetData();
          } else {
            this.showSnackbar("red", res.data.snackbar);
            sessionStorage.setItem("error-trace", res.data.error_trace);
          }
          this.overlay = false;
        })
        .catch((error) => {
          this.onerror(error);

          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
          // this.selected_date=""
        });
    },
    // getDivOffByStandard() {
    //   const data = {
    //     ay: this.ay,
    //     standard: this.standard,
    //   };
    //   axios
    //     .post("/AccountingAndFees/getDivOffByStandard", data)
    //     .then((res) => {
    //       if (res.data.flag == "YES") {
    //         this.division_offering_list = res.data.division_offering_list;
    //       } else {
    //         this.showSnackbar("red", res.data.snackbar);
    //         sessionStorage.setItem("error-trace", res.data.error_trace);
    //       }
    //     })
    //     .catch((error) => {
    //       this.onerror(error);
    //     })
    //     .finally(() => {});
    // },
    formatDate(date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;
      const [month, day, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    },
    onerror(error) {
      let msg = "";
      if (error.response) {
        msg = "Something went wrong.";
      } else if (error.request) {
        msg = "Please try again.";
      } else {
        msg = "Un-expected error.";
      }
      this.showSnackbar("error", msg);
    },
    //////////////////////////////////////
    onload() {
      this.renderComponent = false;
      axios
        .post("AcademicPlanner/adminAcademicPlannerForEmployee")
        .then((res) => {
          if (res.data.flag == "YES") {
            (this.ay_list = res.data.ay_list), (this.ay = res.data.curreny_ay);
            this.mark_holiday_ay = res.data.curreny_ay;
            this.event_type_list = res.data.event_type_list;
            this.planning_list = res.data.planning_list;
            this.day_list = res.data.day_list;
            this.overlay = false;
            this.renderComponent = true;
            // for calender
          } else {
            this.showSnackbar("#b71c1c", res.data.status_reason);
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Something went wrong!!!");
          this.overlay = false;
        })
        .finally(() => {
          this.overlay = false;
        });
    },
  },
};
</script>

<style>
</style>